import ProductSearch from './ProductSearch'

export default ProductSearch
